import { AlertTriangle } from 'lucide-react';
import { Banner } from '@@/api/api-outage-notifications';

export function LoginPageBanner({ banner }: { banner: Banner }) {
  return (
    <div className='max-w-[1100px] mx-auto mb-4 pt-8'>
      <div className='rounded-lg flex items-center gap-3 px-4 py-2.5 text-white border-2 border-white min-h-12'>
        <AlertTriangle className='h-6 w-6 flex-shrink-0 text-white' aria-hidden />
        <span className='text-sm flex-1 text-left'>
          {banner.updatedAt && (
            <span className='font-medium'>
              Updated{' '}
              {new Date(banner.updatedAt)
                .toLocaleTimeString('en-US', {
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: true,
                  timeZone: 'America/New_York'
                })
                .toLowerCase()}{' '}
              EST:{' '}
            </span>
          )}
          {banner.message}
        </span>
      </div>
    </div>
  );
}

export default LoginPageBanner;
